import * as actionTypes from '../actions/actionTypes';

const initialState = {
  loading: false,
  data: [],
  chat: {}, // stores file upload success failure value
  pendingRequests: 0 // dynamic variable to track no. of pending requests and responses 
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CHAT_USERS_START:
      return {
        loading: true,
        data: [],
      };
    case actionTypes.GET_CHAT_USERS_SUCCESS:
      return {
        loading: false,
        data: action.payload.data,
      };
    case actionTypes.GET_CHAT_USERS_FAIL:
      return {
        data: [],
        loading: false,
        error: action.payload.error,
      };
    case actionTypes.SET_CHAT_LOADER:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case actionTypes.UPLOAD_FILE_START:
      return {
        ...state
      };
    case actionTypes.UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        chat: action.payload,
      };
    case actionTypes.UPLOAD_FILE_FAIL:
      return {
        ...state,
        chat: action.payload,
      };
    case actionTypes.IS_PENDING_REQUEST:
      return {
        ...state,
        pendingRequests: action.payload
      }
    default:
      return state;
  }
};

export default reducer;
